import React from "react";
import PropTypes from "prop-types";

const SmallFillButton = ({
  name = "",
  type = "button",
  disabled = false,
  onClick,
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className="button-small-fill"
      >
        {name}
      </button>
    </div>
  );
};

SmallFillButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default SmallFillButton;
